<template>
    <section class="ad-sec4">
        <div v-if="width > 1024" class="ad-sec4-bg"></div>
        <div class="ad-sec4-container">
            <img v-if="width > 768" :src="imageSrc" alt="" class="ad-sec4-img"/>
            <div class="ad-sec4-content">
                <div class="ad-sec4-header">
                    <img v-if="width <= 768"  src="../assets/images/ads-icon.png" />
                    <h2>{{ title }}</h2>
                </div>
                 <div class="ad-sec4-list">
                  <p v-for="item in benefits" :key="item">{{ item }}</p>
                 </div>
            </div>
        </div>
    </section>
</template>

<script>
import { inject } from 'vue';
export default {
    name: "AdSection4",
    props: {
        imageSrc: {
          type: String,
          required: true
        },
        title: {
          type: String,
          required: true
        },
        benefits: {
          type: Array,
          required: true
        },
      },
    setup() {
        const width = inject('viewportWidth');

        return {
            width,

        }

    }
};
</script>

<style scoped>
.ad-sec4 {
    padding-block: 3.27%;
    max-height: 393px;
    position: relative;
}

.ad-sec4-bg {
    height: 299px;
    background-image: url('../assets/images/section-bg-4.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.ad-sec4-container {
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    margin-inline: 10.973% 21.792%;
}

.ad-sec4-container,
.ad-sec4-header {
       justify-content: space-between;
}

.ad-sec4-container,
.ad-sec4-header,
.ad-sec4-list p {
    display: flex;
    align-items: center;
}

.ad-sec4-img {
    aspect-ratio: 399 / 392;
    width: 44%;
    max-width: 399px;
    max-height: 392px;
    flex-shrink: 0;
    animation: fadeRight 2s ease-out forwards;
}

.ad-sec4-img,
.ad-sec4-header img {
     object-fit: contain;
}

.ad-sec4-header {
    margin-bottom: 8.1%;
}

.ad-sec4-header img {
    aspect-ratio: 1 / 1;
    width: 60px;
}

.ad-sec4-header h2 {
    font-size: 28px;
    font-family: 'IRANYekan-Bold';
}

.ad-sec4-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.ad-sec4-list p {
    width: 183px;
    height: 52px;
    font-size: 15px;
    background-color: var(--glass-morphism);
    box-shadow: 0 2px 10px var(--shadow-light);
    backdrop-filter: blur(20px);
    border-radius: 200px;
    justify-content: center;
}

@media screen and (min-width:1441px) {
    .ad-sec4-container {
        width: 925px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .ad-sec4 {
        padding-block: 0;
    }

    .ad-sec4-container {
        margin-inline: 9.973%;
        position: unset;
    }

    .ad-sec4-img {
        width: 40%;
    }

    .ad-sec4-header h2 {
        font-size: 24px;
    }

    .ad-sec4-list {
        gap: 19px;
    }

    .ad-sec4-list p {
        width: 171px;
    }
}

@media screen and (max-width: 768px) {
    .ad-sec4-container {
        margin-inline: 11.7%;
        justify-content: center;
    }

    .ad-sec4-list {
        grid-template-columns: 1fr;
        gap: 16px;
        justify-items: stretch;
    }

    .ad-sec4-list p {
        width: unset;
        height: 47px;
    }
}

@media screen and (max-width: 375px) {
    .ad-sec4-header {
        margin-bottom: 6.6%;
    }

    .ad-sec4-header h2 {
        font-size: 20px;
    }

    .ad-sec4-list p {
        font-size: 14px;
    }
}
</style>